import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './Crosshair.module.scss';

const cx = classNames.bind(styles);

const Crosshair = ({ size = 24, color = 'black', thick = 2 }) => {
  return (
    <div
      className={cx('container')}
      style={{
        width: size,
        height: size,
        '--color': color,
        '--thick': `${thick}px`,
      }}
    />
  );
};

Crosshair.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  thick: PropTypes.number,
};

export default Crosshair;
